/*
 * Add middleware functions into the `middleware.js` file
 *
 * For each middleware use the form:
 *		export const methodName = (params) => draftSearchData => {
 *			[add logic and data manipulations here]
 * 			return draftSearchData;
 * 		}
 *
 */

import _cloneDeep from 'lodash.cloneDeep';

export const processMiddleware = (searchData, middlewares) => {
	return middlewares.reduce(async (output, middleware) => {
		return middleware(await output);
	}, _cloneDeep(searchData));
};